<!-- 
  © 2025 Ananda Kumar. All rights reserved.
  Unauthorized copying of this file, via any medium, is strictly prohibited.
-->
<div
  *ngIf="isAdmin$ | async"
  class="px-2 pt-2 bg-white position-sticky w-100 d-flex flex-column align-items-end rounded mb-3 p-1"
  style="top: 54px; z-index: 4; border-radius: 8px"
>
  <div class="form-check">
    <input
      class="form-check-input"
      type="checkbox"
      [(ngModel)]="isReorder"
      id="reorderToggle"
      (ngModelChange)="onReorderToggle($event)"
      [ngModelOptions]="{standalone: true}"
      [disabled]="!allowRearrange"
    />
    <label class="form-check-label ms-1" for="reorderToggle"
      >Reorder Images</label
    >
  </div>
</div>

<div
  #scrollContainer
  class="scrollable-grid"
  [ngStyle]="{ 'overflow-y': isReorder ? 'hidden' : 'auto' }"
  infiniteScroll
  [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="200"
  [scrollWindow]="false"
  (scrolled)="onScrollEnd.emit()"
>
  <div class="container-fluid m-0 p-0 pb-3">
    <div
      class="row"
      (mousemove)="onMouseMove($event)"
      (mouseup)="onMouseUp()"
      (touchmove)="onTouchMove($event)"
      (touchend)="onTouchEnd()"
    >
      <div class="col-4 col-lg-2" *ngFor="let image of images; let i = index; trackBy: trackById">
        <div
          class="gallery-item position-relative"
          [class.dragging]="
            allowRearrange && dragImageId === image.id && image.selected
          "
          [class.drag-disabled]="!allowRearrange || !image.selected"
          (touchstart)="onTouchStart($event, image, i)"
          (mousedown)="onMouseDown($event, image, i)"
        >
          <img
            [src]="image.thumbnailUrl || image.imageUrl"
            class="img-fluid"
            [alt]="image.fileName"
            [attr.data-id]="image.id"
            (load)="onImageLoaded(i)"
            [class.selected]="image.selected"
            [class.not-selected]="!image.selected"
            (click)="onImageClick(image, i)"
            (contextmenu)="preventContext($event)"
            loading="lazy"
            [draggable]="isReorder"
          />

          <div
            *ngIf="allowDownload || allowRearrange"
            class="selection-icon"
            [class.selected]="image.selected"
            [class.not-selected]="!image.selected && selectedImages.length > 0"
            (click)="toggleSelection($event, image)"
          >
            <i class="bi bi-check-circle-fill"></i>
          </div>

          <div
            *ngIf="image.loading"
            class="loading-placeholder"
            (click)="onImageClick(image, i)"
          ></div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="selection-bar d-flex justify-content-between align-items-center px-3 py-2"
  *ngIf="selectedImages.length > 0"
>
  <div>
    <i class="bi bi-x" role="button" (click)="clearSelections()"></i>
    <span class="ms-2">{{ selectedImages.length }} items selected</span>
  </div>
  <div class="d-flex align-items-center gap-3">
    <div
      *ngIf="isAdmin$ | async"
      role="button"
      (click)="onDeleteSelectClick()"
      class="d-flex flex-column align-items-center gap-0"
      style="cursor: pointer"
    >
      <i class="bi bi-trash"></i>
      <span style="font-size: 6px; margin-top: -4px">Admin</span>
    </div>
    <i
      *ngIf="showMultiSelectDelete"
      class="bi bi-trash me-2"
      role="button"
      (click)="onDeleteMySelectClick()"
    ></i>
    <i
      *ngIf="allowDownload"
      class="bi bi-download"
      role="button"
      (click)="onDownloadSelectClick()"
    ></i>
  </div>
</div>

<app-lightbox
  *ngIf="lightboxOpen"
  (onClose)="onLightboxClose()"
  [showShareOption]="true"
  (onShare)="shareImage($event)"
  (navNext)="nextImage()"
  (navPrev)="prevImage()"
  (onAdminDelete)="deleteImage($event)"
  (onDelete)="onDeleteClicked($event)"
  [showAdminDelete]="showAdminDelete"
  [lightboxImage]="lightboxImage"
  [showDownloadIcon]="allowDownload"
  [showDeleteIcon]="showDeleteIcon"
></app-lightbox>
